<template>
  <UpdateSave
      :maxWidth="500"
      itemKey="TicketItemOffer"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setItemForm="setItemForm"
      :updateData="updateData"
      @onUpdate="(response) => $emit('onUpdate', response)"
      v-bind="$attrs"
  >
    <template
        v-slot:default="{
          errors,
          ItemForm
        }"
    >
      <v-row>
        <v-col
            cols="12"
        >
          <v-text-field
              v-model="ItemForm.timeEstimation"
              :error-messages="errors.timeEstimation"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Odhadovaný čas"
              type="number"
              suffix="h"
          />
        </v-col>

        <v-col
            cols="12"
        >
          <v-textarea
              v-model="ItemForm.note"
              :error-messages="errors.note"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Poznámka"
              :rows="5"
          />
        </v-col>
      </v-row>
    </template>
  </UpdateSave>
</template>

<script>
  import TicketItemOffers from '@/services/ticket-item-offers'

  import UpdateSave from '@/components/_Part/_Modal/_Save/Update'

  export default {
    name: 'Update',
    props: [
      'id'
    ],
    emits: [
      'onUpdate'
    ],
    components: {
      UpdateSave
    },
    methods: {
      fetchData() {
        return TicketItemOffers
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Upraviť ponuku "' + Item.User.name + '"'
      },
      setItemForm(Item) {
        return {
          timeEstimation: Item.timeEstimation,
          note: Item.note
        }
      },
      updateData(ItemForm) {
        return TicketItemOffers
          .update({
            id: this.id,
            data: ItemForm
          })
      }
    }
  }
</script>
